import React from 'react';
import { MENU_MODE } from '../../user';
import { LoginContainer } from '../LoginContainer';
import RequestResetPasswordContainer from '../RequestResetPasswordContainer';
import RequestResetPasswordConfirmationContainer from '../RequestResetPasswordConfirmationContainer';
import { Footer } from '../Footer';
import styles from '../OnboardingRouter/styles.sass';

const LoginPage = ({ menuMode, feedUrl }) => (
  <div className={styles.onboardingPage}>
    <div className={styles.pageContent}>
      <div className={styles.centeredNav}>
        <h1>Log in to Anchor</h1>
        {menuMode === MENU_MODE.LOGIN && <LoginContainer feedUrl={feedUrl} />}
        {menuMode === MENU_MODE.REQUEST_RESET_PASSWORD && (
          <RequestResetPasswordContainer />
        )}
        {menuMode === MENU_MODE.REQUEST_RESET_PASSWORD_CONFIRMATION && (
          <RequestResetPasswordConfirmationContainer />
        )}
      </div>
    </div>
    <Footer />
  </div>
);

export default LoginPage;
